import * as React from 'react';
import {connect} from 'react-redux';

import {ActivityTypes} from 'nutshell-core/activity-types';
import {Assignables} from 'nutshell-core/assignables';
import {safelyGetFilterByKey} from 'nutshell-core/filter';
import type {FilterObject, Assignable, ActivityType} from 'nutshell-core/types';

import {CheckboxButton} from 'shells/button/checkbox-button/checkbox-button';
import {convertToModels} from 'shells/filter-capsule/convert-to-models';
import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';

import type {NutshellState} from '../../../store';

import {ACTIVITY_REPORT_SCHEMA} from '../report-constants';

import {ActivityReportStatusFilter} from './activity-report-status-filter';

import styles from './activity-report.module.css';

type OwnProps = {
    filters: Array<FilterObject>;
    onFilterSubmit: (filterObj: FilterObject) => void;
    onFilterRemove: (filterKey: string) => void;
};

type StateProps = {
    assignables: Assignable[];
    activityTypes: ActivityType[];
};

type Props = OwnProps & StateProps;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        assignables: Assignables.getAll(state),
        activityTypes: ActivityTypes.getAllLoggable(state),
    };
};

export class ActivityReportFiltersComponent extends React.Component<Props> {
    render() {
        const activityTypeModels = convertToModels(this.props.activityTypes) || [];

        return (
            <>
                {NutClientConfig.hasActivityReportExpansionFF && (
                    <ActivityReportStatusFilter
                        currentFilter={safelyGetFilterByKey(this.props.filters, 'status')}
                        onFilterSubmit={this.props.onFilterSubmit}
                    />
                )}
                <FilterCapsule
                    size='big'
                    collection={convertToModels(this.props.assignables)}
                    filter={safelyGetFilterByKey(this.props.filters, 'participant')}
                    filterName='participant'
                    displayCountOnly={true}
                    // @ts-expect-error
                    schemaField={ACTIVITY_REPORT_SCHEMA.participant}
                    onSubmit={this.props.onFilterSubmit}
                    onUpdate={this.props.onFilterSubmit}
                    onRemove={this.props.onFilterRemove}
                />
                <FilterCapsule
                    size='big'
                    collection={activityTypeModels}
                    filter={safelyGetFilterByKey(this.props.filters, 'activityType')}
                    filterName='activityType'
                    displayCountOnly={true}
                    // @ts-expect-error
                    schemaField={ACTIVITY_REPORT_SCHEMA.activityType}
                    onSubmit={this.props.onFilterSubmit}
                    onUpdate={this.props.onFilterSubmit}
                    onRemove={this.props.onFilterRemove}
                    shouldAllowSelectNone={true}
                />
                <div className={styles['report-filter-checkbox']}>
                    <CheckboxButton
                        label='Include emails'
                        checked={Boolean(safelyGetFilterByKey(this.props.filters, 'includeEmails'))}
                        onChange={this.handleEmailFilterClicked}
                    />
                </div>
                <div className={styles['report-filter-checkbox']}>
                    <CheckboxButton
                        label='Include notes'
                        checked={Boolean(safelyGetFilterByKey(this.props.filters, 'includeNotes'))}
                        onChange={this.handleNotesFilterClicked}
                    />
                </div>
            </>
        );
    }

    handleEmailFilterClicked = (isChecked: boolean) => {
        if (!isChecked) {
            this.props.onFilterRemove('includeEmails');
        } else {
            const data = {
                includeEmails: {
                    data: [
                        {
                            data: 1,
                        },
                    ],
                },
            } as const;
            this.props.onFilterSubmit(data);
        }
    };

    handleNotesFilterClicked = (isChecked: boolean) => {
        if (!isChecked) {
            this.props.onFilterRemove('includeNotes');
        } else {
            const data = {
                includeNotes: {
                    data: [
                        {
                            data: 1,
                        },
                    ],
                },
            } as const;
            this.props.onFilterSubmit(data);
        }
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const ActivityReportFilters = connector(ActivityReportFiltersComponent);
